import "./App.css";
import RouterComponent from "./components/navbar/RouterComponent";
import { useEffect, useState } from "react";
import "./i18n";
import "./styles/style.scss";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";
import Clarity from "@microsoft/clarity";
// import Feedback from "feeder-react-feedback";
// import "./styles/feeder-react-feedback.scss";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import "./styles/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";
import { Footer } from "./components/main/Footer";

const projectId = process.env.REACT_APP_MS_CLARITY_ID;
const googleAnalyticsId = process.env.REACT_APP_GA_ID;
const googleAdsensePublisherId = process.env.REACT_APP_ADSENSE_PUBLISHER_ID;

const ADSENSE_SCRIPT_ID = "google-adsense-script";

function App() {
  const [cookieConsentLoaded, setCookieConsentLoaded] = useState(false);

  // Load AdSense independently of cookie-consent callbacks so ads are available on every visit.
  useEffect(() => {
    updateAdsenseConsent(true);
  }, []);

  useEffect(() => {
    const existingConsent = CookieConsent.getCookie();

    if (existingConsent.consentId === undefined && !cookieConsentLoaded) {
      //TODO FIX SO THE FETCH ONLY HAPPENS WHEN CONSENT IS NOT ACCEPTED YET
      // Fetch user's country code using ipinfo.io
      fetch("https://ipinfo.io/json")
        .then((res) => res.json())
        .then((data) => {
          const country = data.country;
          const region = data.region;
          const otherCountries = ["JP", "BR", "CA", "KR", "CH", "GB", "ZA"];
          const gdprCountries = [
            "AT",
            "BE",
            "BG",
            "HR",
            "CY",
            "CZ",
            "DK",
            "EE",
            "FI",
            "FR",
            "DE",
            "GR",
            "HU",
            "IS",
            "IE",
            "IT",
            "LV",
            "LI",
            "LT",
            "LU",
            "MT",
            "NL",
            "NO",
            "PL",
            "PT",
            "RO",
            "SK",
            "SI",
            "ES",
            "SE",
          ];
          const isGDPR = gdprCountries.includes(country);
          const isOther = otherCountries.includes(country);
          const isCalifornia = country === "US" && region === "California";

          if (isGDPR || isCalifornia || isOther) {
            runCookieConsent();
            updateAdsenseConsent(true);
          } else {
            // Non-restricted regions use the existing implicit analytics behavior.
            initializeAnalytics();
            updateAdsenseConsent(true);
          }
        })
        .catch(() => {
          // If geolocation fails, show Cookie Consent by default
          runCookieConsent();
          updateAdsenseConsent(true);
          setCookieConsentLoaded(true);
        });
    } else if (existingConsent.consentId !== undefined || cookieConsentLoaded) {
      runCookieConsent();
    }
  });
  // ...existing code...

  const { t } = useTranslation();

  let mybutton = document.getElementById("btn-back-to-top");

  // When the user scrolls down 20px from the top of the document, show the button
  window.onscroll = function () {
    scrollFunction();
  };

  // Helper to run CookieConsent
  function runCookieConsent() {
    CookieConsent.run({
      guiOptions: {
        consentModal: {
          layout: "box wide",
          position: "bottom center",
          equalWeightButtons: true,
          flipButtons: false,
        },
        preferencesModal: {
          layout: "box",
          position: "right",
          equalWeightButtons: true,
          flipButtons: false,
        },
      },
      categories: {
        necessary: {
          enabled: true,
          readOnly: true,
        },
        analytics: {},
        advertising: {},
      },
      language: {
        default: "en",
        translations: {
          en: {
            consentModal: {
              title: "We use cookies to improve your experience.",
              description:
                "By using our site, you agree to our use of cookies.",
              acceptAllBtn: "Accept all",
              acceptNecessaryBtn: "Accept necessary",
              showPreferencesBtn: "Learn more",
            },
            preferencesModal: {
              title: "Manage cookie preferences",
              acceptAllBtn: "Accept all",
              savePreferencesBtn: "Save preferences",
              closeIconLabel: "Close modal",
              sections: [
                {
                  title: "Cookie Usage",
                  description:
                    "We use cookies to improve your experience. By using our site, you agree to our use of cookies. Here you can manage your cookie preferences.",
                },
                {
                  title: "Strictly Necessary cookies",
                  description:
                    "These cookies are essential for the proper functioning of the website and cannot be disabled. For example, they enable you to log into secure areas of our website, save your preferances and so on.",
                  linkedCategory: "necessary",
                },
                {
                  title: "Analytics",
                  description:
                    "These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.",
                  linkedCategory: "analytics",
                  cookieTable: {
                    headers: {
                      name: "Name",
                      domain: "Service",
                      description: "Description & Terms",
                      expiration: "Expiration",
                    },
                    body: [
                      {
                        name: "_ga",
                        domain: "Google Analytics",
                        description:
                          'Cookie set by <a href="https://marketingplatform.google.com/about/analytics/terms/us/" target="_blank">Google Analytics</a>',
                        expiration: "Expires after 12 days",
                      },
                      {
                        name: "_clck",
                        domain: "Microsoft Clarity",
                        description:
                          'Cookie set by <a href="https://www.microsoft.com/privacy/privacystatement" target="_blank">Microsoft Clarity</a>',
                        expiration: "Expires after 30 days",
                      },
                    ],
                  },
                },
                {
                  title: "Advertising",
                  description:
                    "Allow Google AdSense to load and display ads. Google may use cookies or similar storage for ad delivery, measurement, and personalization where permitted.",
                  linkedCategory: "advertising",
                  cookieTable: {
                    headers: {
                      name: "Name",
                      domain: "Service",
                      description: "Description & Terms",
                      expiration: "Expiration",
                    },
                    body: [
                      {
                        name: "__gads, __gpi",
                        domain: "Google AdSense",
                        description:
                          '<a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">Google advertising cookies</a>',
                        expiration: "Varies",
                      },
                    ],
                  },
                },
                {
                  title: "More information",
                  description:
                    'For any queries in relation to the policy on cookies and your choices, please <a href="mailto:privacy@andrewscookin.com">contact us</a>',
                },
              ],
            },
          },
        },
      },
      onFirstConsent: () => {
        logConsent();
      },
      onConsent: (cookie) => {
        const preferences = CookieConsent.getUserPreferences();
        const acceptedCategories = preferences?.acceptedCategories || [];
        if (acceptedCategories.includes("analytics")) {
          initializeAnalytics();
        }
        // updateAdsenseConsent(acceptedCategories.includes("advertising"));
        setCookieConsentLoaded(true);
      },
      onChange: () => {
        logConsent();
        const preferences = CookieConsent.getUserPreferences();
        const acceptedCategories = preferences?.acceptedCategories || [];
        // updateAdsenseConsent(acceptedCategories.includes("advertising"));
      },
    });
  }

  function initializeAnalytics() {
    ReactGA.initialize(googleAnalyticsId);
    Clarity.init(projectId);
    Clarity.consent();
  }

  /** Loads or removes the AdSense loader according to advertising consent. */
  function updateAdsenseConsent(hasAdvertisingConsent) {
    const existingScript = document.getElementById(ADSENSE_SCRIPT_ID);

    if (!hasAdvertisingConsent) {
      existingScript?.remove();
      return;
    }

    // Avoid making an invalid request if the deployment has not configured its publisher ID.
    if (!googleAdsensePublisherId || !/^ca-pub-\d+$/.test(googleAdsensePublisherId)) {
      console.error("AdSense is enabled in consent settings but REACT_APP_ADSENSE_PUBLISHER_ID is missing or invalid.");
      return;
    }

    if (existingScript) return;

    const script = document.createElement("script");
    script.id = ADSENSE_SCRIPT_ID;
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(googleAdsensePublisherId)}`;
    document.head.appendChild(script);
  }

  function logConsent() {
    // Retrieve all the fields
    const cookie = CookieConsent.getCookie();
    const preferences = CookieConsent.getUserPreferences();

    const userConsent = {
      userId: "123", //TODO: replace with actual user ID
      consentId: cookie.consentId,
      acceptType: preferences.acceptType,
      acceptedCategories: preferences.acceptedCategories,
      rejectedCategories: preferences.rejectedCategories,
    };

    console.log("user consent sent");
    // fetch(process.env.REACT_APP_SPRING_API + "/utils/log-user-consent", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify(userConsent),
    // }).catch(() => console.log("Failed to send user consent"));
  }

  function scrollFunction() {
    if (
      document.body.scrollTop > 650 ||
      document.documentElement.scrollTop > 650
    ) {
      mybutton.style.display = "block";
    } else {
      mybutton.style.display = "none";
    }
  }
  // When the user clicks on the button, scroll to the top of the document
  mybutton != null && mybutton.addEventListener("click", backToTop);

  function backToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // document.body.scrollTop = 0;
    // document.documentElement.scrollTop = 0;
  }

  return (
    <div className="App">
      <RouterComponent />
      {/* <Feedback
        projectId={process.env.REACT_APP_FEEDER_PROJECT_ID}
        email={process.env.REACT_APP_FEEDER_EMAIL}
        projectName="Andrew"
        postSubmitButtonMsg="Thanks! I value your Feedback"
        feedbackTypes={["Bug", "Idea"]}
      /> */}
      <Footer />
    </div>
  );
}

export default App;
